<template>
  <!-- 导出年度分析报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
      <div class="chart_box page-box flex-box">
        <div>
          <div class="header_titles">
            <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
            <input id="completeNum" v-model="completeNum" v-show="false" />
            <h1>职业教育“{{ header.zykName }}”专业教学资源库</h1>
            <h1 style="margin-top: 15px">月度运行数据分析报告（{{ yearMonthText }}）</h1>
            <span style="font-size: 22px;font-weight: bold;color: #1d244e;">（分析时间：{{ header.startTime }} 至 {{ header.endTime }}）</span>
            <div class="number_time" style="line-height: 45px">
              <div>
                <span>主持单位：{{ header.allHostUnit }}</span>
              </div>
              <div>
                <span>核心专业：{{ processName(header.zykName) }}</span>
                <span>服务专业：{{ serviceMajor }}</span>
              </div>
              <p style="width:100%"></p>
              <p style="width:100%"></p>
            </div>
          </div>
          <div class="division">1. 当前资源库总体情况</div>
          <h4>1.1 当前资源库用户情况</h4>
          <p>
            当前该资源库的用户总数{{ dataHandler(resourceLibrary.total) }}人，其中学生{{
            dataHandler(resourceLibrary.studentNum)
            }}人,实名注册{{ dataHandler(realNameZykUser.student) }}人；教师{{ dataHandler(resourceLibrary.teacherNum) }}人,实名注册{{ dataHandler(realNameZykUser.teacher) }}人；社会学习者{{
            dataHandler(resourceLibrary.socialNum)
            }}人,实名注册{{ dataHandler(realNameZykUser.social) }}人；企业用户{{ dataHandler(resourceLibrary.enterpriseNum) }}人,实名注册{{ dataHandler(realNameZykUser.enterprise) }}人。具体如图1所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'resourceLibraryChart'"
              :isShowTextColor="true"
              :datas="resourceLibrary.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
              :legendListFontSize="30"
            />
          </div>
          <div class="chart_name">图1 资源库注册用户类型分布总体情况</div>
        </div>
        <div>
          <h4>1.2 当前资源库建设单位注册用户情况</h4>
          <p>
            当前该资源库建设单位核心专业及服务专业教师用户{{
            dataHandler(userCountUnit.teacherNum)
            }}人，其中主持单位核心专业及服务专业的教师用户{{
            dataHandler(userCountUnit.zcteacherNum)
            }}人，已实名注册{{ dataHandler(unitRealNameZykUser.teacher) }}人；参建单位核心专业及服务专业的教师用户{{
            dataHandler(userCountUnit.cjteacherNum)
            }}人，已实名注册{{ dataHandler(unitRealNameZykUser.buildTeacher) }}人。建设单位核心专业及服务专业学生用户{{
            dataHandler(userCountUnit.studentNum)
            }}人，其中主持单位核心专业及服务专业的学生用户{{
            dataHandler(userCountUnit.zcstudentNum)
            }}人，已实名注册{{ dataHandler(unitRealNameZykUser.student) }}人；
            参建单位核心专业及服务专业的学生用户{{ dataHandler(userCountUnit.cjstudentNum) }}人，
            已实名注册{{ dataHandler(unitRealNameZykUser.buildStudent) }}人。具体如图2所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'resourceLibraryChart'"
              :isShowTextColor="true"
              :datas="userCountUnit.teacherList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'55%'"
              :circleSize="80"
              :legendListFontSize="30"
            />
          </div>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'resourceLibraryChart'"
              :isShowTextColor="true"
              :datas="userCountUnit.studentList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'55%'"
              :circleSize="80"
              :legendListFontSize="30"
            />
          </div>
          <div class="chart_name">图2 当前资源库建设单位注册用户情况</div>
        </div>
      </div>

      <div class="chart_box page-box">
        <h4>1.3 当前资源库资源建设情况</h4>
        <p>
          当前该资源库的素材资源总数{{ dataHandler(typeDistribution.total) }}条，
          资源内容存储总量{{ formatValue(statResourceDataCapacity.total/1024)  }}GB。
          其中文本类{{
          dataHandler(typeDistribution.wbNumber)
          }}条，资源存储量{{ formatValue(statResourceDataCapacity.textNum/1024) }}GB；
          图形图像类{{ dataHandler(typeDistribution.txtxNumber) }}条，资源存储量{{ formatValue(statResourceDataCapacity.graphicImageNum/1024) }}GB；
          视频类{{
          dataHandler(typeDistribution.spNumber)
          }}条，资源存储量{{ formatValue(statResourceDataCapacity.videoNum/1024) }}GB；
          动画类{{ dataHandler(typeDistribution.dhNumber) }}条，资源存储量{{ formatValue(statResourceDataCapacity.animationNum/1024) }}GB；
          虚拟仿真类{{
          dataHandler(typeDistribution.xnfzNumber)
          }}条，资源存储量{{ formatValue(statResourceDataCapacity.virtualSimulationNum/1024) }}GB；
          微课类{{ dataHandler(typeDistribution.wkNumber) }}条，资源存储量{{ formatValue(statResourceDataCapacity.smallCourseNum/1024) }}GB；
          音频类{{
          dataHandler(typeDistribution.ypNumber)
          }}条，资源存储量{{ formatValue(statResourceDataCapacity.shenyangNum/1024) }}GB；
          ppt和富媒体等{{
          dataHandler(
          typeDistribution.pptNumber + typeDistribution.kjNumber + typeDistribution.fmtNumber
          )
          }}条，资源存储量{{ formatValue((statResourceDataCapacity.pptNum+statResourceDataCapacity.mediaNum+statResourceDataCapacity.coursewareNum)/1024) }}GB；
          其他{{ dataHandler(typeDistribution.qtNumber) }}条，资源存储量{{ formatValue(statResourceDataCapacity.otherNum/1024) }}GB。具体如图3所示。<br/>
          <span style="text-indent: 2em;display: inline-block">
            当前该资源库核心专业人才培养方案{{ resourceConstructionSituation.talentTrainingNum }}份；
            标准化课程知识图谱{{ resourceConstructionSituation.knowledgeGraphNum }}份；
            课程教学标准或规范{{ resourceConstructionSituation.teachingStandardNum }}份；
            题库有{{ resourceConstructionSituation.questionNum }}道题，题库使用率{{ resourceConstructionSituation.questionBankUseRate }}%。
          </span>
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="typeDistribution.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="chart_name">图3 资源库素材资源类型分布</div>
        <h4 class="m-top150">1.4 当前资源库标准化课程建设及应用情况</h4>
        <p>
          当前该资源库建有标准化课程{{
          dataHandler(standardization.courseBzNum)
          }}门，按访问量排名前10名如图4所示。
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :refId="'standardizationChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="standardization.dataList"
            :transverseData="standardization.transverseData"
            :colorList="standardization.colorList"
            :seriesColor="true"
          />
        </div>
        <div class="chart_name">图4 该资源库标准化课程访问量排名（前10名）</div>
        <div class="notes">
          （注1：标准化课程指资源库建设团队按照《指南》要求建设和提供的，涵盖课程基本知识点和技能点，能够适应
          全国同类和相近专业在线教学基本需要的结构化课程。标准化课程的正确性、逻辑性、权威性由资源库建设团队保
          证。个性化课程指教师在使用资源库过程中，结合自身实际教学需要和学生特点，对标准化课程进行改造、补充、
          重构后形成的个性化课程。个性化课程的正确性、逻辑性由建课教师自行保障。注2：如标准化课程或个性化课程
          显示为0，表明该资源库在课程标注上不规范，需要在资源库运行平台中对课程分类重新标注。）
        </div>
      </div>

      <div class="chart_box page-box">
        <h4>1.5 当前资源库用户行为类型分布</h4>
        <p>
          该资源库用户行为活动总量为{{ dataHandler(behaviorTypes.total) }}次，其中课程模块{{
          dataHandler(behaviorTypes.courseModule)
          }}次，资源素材模块{{ dataHandler(behaviorTypes.resourceModule) }}次，论坛模块{{
          dataHandler(behaviorTypes.forumModule)
          }}次，作业模块{{ dataHandler(behaviorTypes.taskModule) }}次，考试模块{{
          dataHandler(behaviorTypes.examinationModule)
          }}次，其他模块{{ dataHandler(behaviorTypes.otherModule) }}次。具体如图5所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'behaviorTypesChart'"
            :datas="behaviorTypes.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'55%'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="chart_name">图5 资源库用户行为类型分布</div>
        <h4 class="m-top150">1.6 资源库无活动数据情况</h4>
        <p>
          该资源库建设单位核心专业及服务专业已实名教师总数{{
          dataHandler(resourcePool.realTeacher)
          }}人，其中无活动教师{{
          dataHandler(resourcePool.countTeacher)
          }}人；建设单位近三年核心专业及服务专业注册已实名学生总数{{
          dataHandler(resourcePool.realStudent)
          }}人，其中无活动学生{{ dataHandler(resourcePool.countStudent) }}人；资源总数{{
          dataHandler(typeDistribution.total)
          }}条，其中无访问资源{{
          dataHandler(resourcePool.countResource)
          }}条；请继续关注应用情况，监督其深入应用。具体如图6所示。
        </p>
        <div class="speed">
          <el-row>
            <el-col :span="10">
              <div class="right">实名教师中无活动教师占比:</div>
            </el-col>
            <el-col :span="14">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="teacherFormat"
                :percentage="waterDrop.teacher"
                color="#3B86FF"
              />
            </el-col>

            <el-col :span="10">
              <div class="right">实名学生中无活动学生占比:</div>
            </el-col>
            <el-col :span="14">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="studentFormat"
                :percentage="waterDrop.student"
                color="#63D0FF"
              />
            </el-col>

            <el-col :span="10">
              <div class="right">无访问资源占比:</div>
            </el-col>
            <el-col :span="14">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="resourceFormat"
                :percentage="waterDrop.resource"
                color="#BBA8FF"
              />
            </el-col>
          </el-row>
        </div>
        <div class="chart_name">图6 资源库无活动数据情况</div>
        <div v-if="isRank === 'yes'">
          <h4 class="m-top150">1.7 资源库综合排名情况</h4>
          <p v-if="top.zykRank <= 188">
            当前，该资源库建设单位已实名但无活动用户数（教师和学生）{{
            top.noStudentAndTearch
            }}人；该资源库无活动资源{{ top.noActiveResource }}条。
            根据资源库开展应用情况，取半年度访问量、上述无活动用户数、上述无活动资源数等多项指标进行综合排名，本资源库在203个国家级专业教学资源库中排名第{{
            top.zykRank
            }}名，请继续深入推广应用。
          </p>
          <p v-if="top.zykRank > 188">
            当前，该资源库建设单位已实名但无活动用户数（教师和学生总数）{{
            top.noStudentAndTearch
            }}人；该资源库无活动资源{{ top.noActiveResource }}条。
            根据资源库开展应用情况，取半年度访问量、上述无活动用户数、上述无活动资源数等多项指标进行综合排名，本资源库在203个国家级专业教学资源库中排名属于后15名，请加大资源库的推广应用力度。
          </p>
        </div>
      </div>

      <div class="chart_box page-box">
        <!--<div class="division">2. {{ yearText }}年资源库新增情况</div>-->
        <div class="division">2.本月资源库新增情况</div>
        <h4>2.1 本月用户新增情况</h4>
        <p>
          该资源库本月新增教师用户数{{ usersMonth.teacherNum }}人，新增学生用户数{{
          usersMonth.studentNum
          }}人，新增企业用户数{{ usersMonth.enterpriseNum }}人，新增社会学习者用户数{{
          usersMonth.socialNum
          }}人，具体新增情况如图7所示。
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="usersMonth.dataList"
            :transverseData="usersMonth.transverseData"
            :colorList="usersMonth.colorList"
            :legendList="usersMonth.legendList"
            :innerText="'单位：人'"
            :gridLeft="'8%'"
          />
        </div>
        <div class="chart_name">图7 本月用户新增情况</div>
        <p>
          该资源库本月新增用户中，主持单位新增教师数{{
          dataHandler(majorUser.teacher)
          }}人，参建单位新增教师数{{ dataHandler(majorUser.cjteacher) }}人，主持单位新增学生数{{
          dataHandler(majorUser.student)
          }}人，参建单位新增学生数{{
          dataHandler(majorUser.cjstudent)
          }}人，主持单位与参建单位新增占比情况具体如图8所示。
        </p>
        <div class="speed">
          <el-row>
            <el-col :span="6">
              <div style="font-size: 29px">主持单位新增教师占比:</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :percentage="waterDrop.majorteacherNum"
                color="#3B86FF"
              />
            </el-col>
            <el-col :span="6">
              <div style="font-size: 29px">参建单位新增教师占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :percentage="waterDrop.unitteacherNum"
                color="#63D0FF"
              />
            </el-col>
            <el-col :span="6">
              <div style="font-size: 29px">主持单位新增学生占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :percentage="waterDrop.majorstudentNum"
                color="#BBA8FF"
              />
            </el-col>
            <el-col :span="6">
              <div style="font-size: 29px">参建单位学生新增占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :percentage="waterDrop.unitstudentNum"
                color="#7F88FE"
              />
            </el-col>
          </el-row>
        </div>
        <div class="chart_name">图8 本月主持单位与参建单位新增用户占比情况</div>
        <h4>2.2 本月素材资源新增情况</h4>
        <p>该资源库本月新增素材资源{{ resourcesMonth.total }}条，具体新增情况如图9所示。</p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'resourcesInsertChart'"
            :datas="resourcesMonth.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'55%'"
            :showValue="true"
            :unit="'条'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :refId="'resourcesMonthChart'"
            :legendList="resourcesMonth.legendList"
            :datas="resourcesMonth.dataList2"
            :transverseData="resourcesMonth.transverseData"
            :colorList="resourcesMonth.colorList"
            :colorName="1"
            :innerText="'单位：条'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :isShowTextColor="true"
            :isExportTextColor="true"
          >
          </vcolumnarChart>
        </div>
        <div class="chart_name">图9 本月资源新增情况</div>
      </div>

      <div class="chart_box page-box">
        <h4>2.3 本月课程新增情况</h4>
        <p>
          该资源库本月新增课程总数{{ coursesMonth.total }}门，其中标准化课程{{
          coursesMonth.standard
          }}门，个性化课程{{ coursesMonth.personal }}门。具体新增情况如图10所示。
        </p>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :refId="'lastcoursesMonthChart'"
            :legendList="coursesMonth.legendList"
            :datas="coursesMonth.dataList"
            :transverseData="coursesMonth.transverseData"
            :colorList="barColorList"
            :colorName="1"
            :innerText="'单位：门'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :isShowTextColor="true"
            :isExportTextColor="true"
          />
        </div>
        <div class="chart_name divorced">图10 本月课程新增情况</div>

        <!--<div class="division" style="margin: 100px 0 50px 0">3. {{ yearText }}年资源库应用情况</div>-->
        <div class="division" style="margin: 100px 0 50px 0">3 . 本月资源库应用情况</div>
        <div class="flex-box">
          <div>
            <h4>3.1 本月资源访问情况</h4>
            <p>
              该资源库本月资源访问数{{
              accessMonth.total > 10000
              ? (accessMonth.total / 10000).toFixed(2) + "万"
              : accessMonth.total
              }}次，具体访问情况如图11所示。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'accessMonthChart'"
                :datas="accessMonth.dataList"
                :transverseData="accessMonth.transverseData"
                :colorList="accessMonth.colorList"
                :legendList="accessMonth.legendList"
                :innerText="'单位：次'"
                :isShowTextColor="true"
                :isExportTextColor="true"
              >
              </discountChart>
            </div>
            <div class="chart_name">图11 本月资源访问情况</div>
          </div>

          <div>
            <h4>3.2 本月课程访问情况</h4>
            <p>
              该资源库本月课程访问数{{
              visitsMonth.total > 10000
              ? (visitsMonth.total / 10000).toFixed(2) + "万"
              : visitsMonth.total
              }}次，具体访问情况如图12所示。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'visitsMonthChart'"
                :datas="visitsMonth.dataList"
                :transverseData="visitsMonth.transverseData"
                :colorList="visitsMonth.colorList"
                :legendList="visitsMonth.legendList"
                :innerText="'单位：次'"
                :isShowTextColor="true"
                :isExportTextColor="true"
              >
              </discountChart>
            </div>
            <div class="chart_name">图12 本月课程访问情况</div>
          </div>
        </div>
      </div>

      <div class="chart_box page-box">
        <h4>3.3 本月用户访问情况</h4>
        <p>
          该资源库本月用户访问量{{
          userAccessMonth.total > 100000000
          ? (userAccessMonth.total / 100000000).toFixed(2) + "亿"
          : userAccessMonth.total > 10000
          ? (userAccessMonth.total / 10000).toFixed(2) + "万"
          : userAccessMonth.total
          }}次，具体访问情况如图13所示。
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'userAccessMonthChart'"
            :datas="userAccessMonth.dataList"
            :transverseData="userAccessMonth.transverseData"
            :colorList="userAccessMonth.colorList"
            :legendList="userAccessMonth.legendList"
            :innerText="'单位：次'"
            :isShowTextColor="true"
            :isExportTextColor="true"
          />
        </div>
        <div class="chart_name">图13 本月用户访问情况</div>
        <p class="m-top150">用户访问时间段分布具体如图14所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'behaviorUserChart'"
            :datas="behaviorUser.dataList"
            :transverseData="behaviorUser.transverseData"
            :colorList="colorList"
            :legendList="behaviorUser.legendList"
            :innerText="'单位：次'"
            :isShowTextColor="true"
            :isExportTextColor="true"
          />
        </div>
        <div class="chart_name">图14 本月用户访问时间段分布</div>
        <h4 class="m-top150">3.4 本月访问较多的教师</h4>
        <div class="chart_name" v-if="tearcherList.dataList.length === 10">
          表1 本月访问较多的教师（前10名）
        </div>
        <div class="chart_name" v-else>表1 本月访问较多的教师</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>姓名</th>
              <th>所属院校</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in tearcherList.dataList"
              :key="index"
              v-show="tearcherList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.school }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="tearcherList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h4>3.5 本月访问较多的学生</h4>
        <div class="chart_name" v-if="studentList.dataList.length === 10">
          表2 本月访问较多的学生（前10名）
        </div>
        <div class="chart_name" v-else>表2 本月访问较多的学生</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>姓名</th>
              <th>所属院校</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in studentList.dataList"
              :key="index"
              v-show="studentList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.school }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="studentList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <h4 class="m-top150">3.6 本月被访问较多的资源</h4>
        <div class="chart_name" v-if="resourcesList.dataList.length === 10">
          表3 本月被访问较多的资源（前10名）
        </div>
        <div class="chart_name" v-else>表3 本月被访问较多的资源</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源名</th>
              <th>资源类型</th>
              <th>创建者姓名</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in resourcesList.dataList"
              :key="index"
              v-show="resourcesList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.mediaType }}</td>
              <td>{{ item.author }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="resourcesList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <h4 class="m-top150">3.7 本月活跃人数较多的课程</h4>
        <div class="chart_name" v-if="courseList.dataList.length === 10">
          表4 本月活跃人数较多的课程（前10名）
        </div>
        <div class="chart_name" v-else>表4 本月活跃人数较多的课程</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名</th>
              <th>类型</th>
              <th>创建者姓名</th>
              <th>活跃人数</th>
            </tr>

            <tr
              v-for="(item, index) in courseList.dataList"
              :key="index"
              v-show="courseList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.author }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="courseList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!--      <div class="division" style="margin: 100px 0 50px 0">4 . 资源库监测效果评级</div>-->
      <!--      <div class="flex-box">-->
      <!--        <div class="chart_box">-->
      <!--          <p style="font-size: 35px;margin: 35px;line-height: 90px;color:#707f9d ">-->
      <!--            当前，资源库运行监测平台针对该资源库的建设及应用情况，取资源、课程、用户三个维度的多个指标进行综合分析，-->
      <!--            该资源库的运行效果在当前已经纳入监测的专业教学资源库中被评为“<span style="font-weight: bolder;color: red">{{rankDesc}}</span>”级，请继续深入推广应用。-->
      <!--          </p>-->
      <!--        </div>-->

    </div>

    <!--<div class="chart_box page-box">
      <div class="division">4. {{ yearText - 1 }}年和{{ yearText }}年建设与应用数据对比分析</div>
      <div class="flex-box" style="padding-top: 50px">
        <div>
          <h4>4.1 资源新增对比分析</h4>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'participatingChart'"
              :datas="zykTotal.dataList"
              :transverseData="zykTotal.transverseData"
              :colorList="barColorList"
              :legendList="zykTotal.legendList"
              :innerText="'单位：条'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            />
          </div>
          <div class="chart_name">
            图14 {{ yearText - 1 }}年资源库资源新增与{{ yearText }}年资源库资源新增对比分析
          </div>
        </div>
        <div>
          <h4>4.2 课程新增对比分析</h4>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'participatingChart'"
              :datas="courseTotal.dataList"
              :transverseData="courseTotal.transverseData"
              :colorList="barColorList"
              :legendList="courseTotal.legendList"
              :innerText="'单位：门'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            />
          </div>
          <div class="chart_name">
            图15 {{ yearText - 1 }}年资源库课程新增与{{ yearText }}年资源库课程新增对比分析
          </div>
        </div>
        <div>
          <h4>4.3 用户新增对比分析</h4>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'participatingChart'"
              :datas="userTotal.dataList"
              :transverseData="userTotal.transverseData"
              :colorList="barColorList"
              :legendList="userTotal.legendList"
              :innerText="'单位：人'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            />
          </div>
          <div class="chart_name">
            图16 {{ yearText - 1 }}年资源库用户新增与{{ yearText }}年资源库用户新增对比分析
          </div>
        </div>
      </div>
    </div>

    <div class="chart_box page-box">
      <h4>4.4 访问量对比分析</h4>
      <div class="standards_content echartsHeight">
        <discountChart
          :isShowTextColor="true"
          :isExportTextColor="true"
          :refId="'resourceLibraryChart'"
          :datas="fangwen.dataList"
          :transverseData="fangwen.transverseData"
          :colorList="fangwen.colorList"
          :legendList="fangwen.legendList"
          :colorName="1"
          :innerText="'单位: 次'"
          :xAxisText="'单位: 月'"
          :titleLeft="'32%'"
          :legendBackgroundColor="true"
          :circleSize="80"
        />
      </div>
      <div class="chart_name">
        图17 {{ yearText - 1 }}年资源库访问量与{{ yearText }}年资源库访问量对比分析
      </div>
    </div>-->
  </div>
  </div>
</template>

<script>
    import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
    import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; // 引入竖柱状图图表
    import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
    import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
    import waterDropChart from "@/components/chart/waterDropChart.vue"; // 引入水滴图图表
    import vcolumnarChartColor from "@/components/chart/vcolumnarChartColor.vue"; // 引入竖柱状图图表
    import pageToPDF from "@/utils/htmlToPdf.js";

    export default {
        components: {
            circularChart,
            vcolumnarChart,
            tcolumnarChart,
            discountChart,
            waterDropChart,
            vcolumnarChartColor,
        },
        data() {
            return {
                rankDesc:"A",
                province: this.$route.query.province,
                serviceMajor:"",
                completeNum: 0, //统计接口数量
                year: "",
                yearMonthText: "",
                yearAndMonthly: "",
                yearText: "",
                zykStatus: "已立项",
                isRank: null,
                colorList: [
                    "#3B85FB",
                    "#FD398E",
                    "#8B68F1",
                    "#EE6F5E",
                    "#E0D35F",
                    "#5470C6",
                    "#DE7E4B",
                    "#DE524B",
                ], // 柱状图或折线图的颜色
                barColorList: ["#3B85FB", "#BBA8FF"],
                header: {
                    allHostUnit: "",
                    coHostUnit: [],
                    endTime: "",
                    hostUnit: "",
                    startTime: "",
                    status: "",
                    zykName: "",
                    zykNum: "",
                },
                resourceLibrary: {
                    //图1 当前资源库用户情况
                    dataList: [],
                    total: 0,
                    teacherNum: 0,
                    studentNum: 0,
                    enterpriseNum: 0,
                    socialNum: 0,
                    otherNum: 0,
                },
                userCountUnit: {
                    //图2 当前资源库参建单位注册用户情况（主持单位学生 + 老师，参建单位用户人数）
                    teacherList: [],
                    studentList: [],
                    teacherNum: 0,
                    studentNum: 0,
                    zcteacherNum: 0,
                    zcstudentNum: 0,
                },

                typeDistribution: {
                    //图3 资源库素材资源类型分布
                    dataList: [],
                    spNumber: 0,
                    dhNumber: 0,
                    txtxNumber: 0,
                    xnfzNumber: 0,
                    wbNumber: 0,
                    wkNumber: 0,
                    ypNumber: 0,
                    kjNumber: 0,
                    pptNumber: 0,
                    fmtNumber: 0,
                    qtNumber: 0,
                    total: 0,
                },
                standardization: {
                    //图4 该资源库标准化课程活跃用户排名
                    dataList: [],
                    transverseData: [],
                    colorList: [],
                    courseBzNum: 0,
                    courseCoreNum: 0
                },
                behaviorTypes: {
                    //图5 资源库用户行为类型分布
                    dataList: [],
                    total: 0,
                    loginModule: 0,
                    courseModule: 0,
                    resourceModule: 0,
                    forumModule: 0,
                    taskModule: 0,
                    examinationModule: 0,
                    otherModule: 0,
                },
                //图14 用户访问时间段分布
                behaviorUser: {
                    dataList: [],
                    transverseData: [],
                    legendList: [],
                },
                resourcePool: {
                    //图6 资源库无活动数据情况,图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况
                    countTeacher: 0,
                    countStudent: 0,
                    realTeacher: 0,
                    realStudent: 0,
                    countResource: 0,
                },
                resourcesInsert: {
                    //图5 资源库用户行为类型分布
                    dataList: [],
                },

                majorUser: {
                    //图8 主持院校与参建院校新增占比情况
                    teacher: 0,
                    student: 0,
                    cjteacher: 0,
                    cjstudent: 0,
                },
                waterDrop: {
                    teacher: 0, //图6 资源库无活动数据情况
                    student: 0, //图6 资源库无活动数据情况
                    resource: 0, //图6 资源库无活动数据情况
                    // lastresource: 0,    //图11 资源库无访问资源较上月变化情况
                    majorteacher: 0, //图8 主持院校与参建院校新增占比情况
                    majorstudent: 0, //图8 主持院校与参建院校新增占比情况
                    unitteacher: 0, //图8 主持院校与参建院校新增占比情况
                    unitstudent: 0, //图8 主持院校与参建院校新增占比情况
                    teacherNum: 0,
                    studentNum: 0,
                    resourceNum: 0,
                    lastresourceNum: 0,
                    majorteacherNum: 0,
                    majorstudentNum: 0,
                    unitteacherNum: 0,
                    unitstudentNum: 0,
                },
                usersMonth: {
                    // 图3 用户新增情况
                    dataList: [],
                    transverseData: [],
                    colorList: [],
                    legendList: [],
                    teacherNum: 0,
                    studentNum: 0,
                },
                resourcesMonth: {
                    // 图4 资源库各类型素材资源新增情况
                    dataList: [],
                    dataList2: [],
                    transverseData: [],
                    legendList: [],
                    colorList: [],
                    total: 0,
                },
                coursesMonth: {
                    // 图5 课程新增情况
                    dataList: [],
                    transverseData: [],
                    colorList: [],
                    legendList: [],
                    total: 0,
                    standard: 0,
                    personal: 0,
                },
                accessMonth: {
                    // 图6 资源访问情况
                    dataList: [],
                    transverse: [],
                    colorList: [],
                    legendList: [],
                },
                visitsMonth: {
                    // 图7 课程访问情况
                    dataList: [],
                    transverseData: [],
                    colorList: [],
                    legendList: [],
                    total: 0,
                },

                userAccessMonth: {
                    // 图8 用户访问情况
                    dataList: [],
                    transverseData: [],
                    colorList: [],
                    legendList: [],
                    total: 0,
                },

                tearcherList: {
                    // 图9  总访问量最多的教师
                    dataList: [],
                },

                studentList: {
                    // 图10 总访问量最多的学生
                    dataList: [],
                },
                resourcesList: {
                    // 图10 总访问量最多的资源
                    dataList: [],
                },
                courseList: {
                    // 图10 总访问量最多的课程
                    dataList: [],
                },
                top: {
                    realTeacher: 0,
                    realStudent: 0,
                    noActiveRealTeacher: 0,
                    noActiveRealStudent: 0,
                    noActiveResource: 0,
                    logCount: 0,
                    zykRank: 0,
                    noStudentAndTearch: 0,
                },
                zykTotal: {
                    dataList: [],
                    colorList: [],
                    transverseData: [],
                    legendList: [],
                },
                fangwen: {
                    dataList: [],
                    colorList: [],
                    transverseData: [],
                    legendList: [],
                },
                courseTotal: {
                    dataList: [],
                    colorList: [],
                    transverseData: [],
                    legendList: [],
                },

                userTotal: {
                    dataList: [],
                    colorList: [],
                    transverseData: [],
                    legendList: [],
                },
                totalNum: 0,
                loading: "", // 是否导出加载中

                realNameZykUser: {},//1.1 当前资源库用户情况 - 实名用户数
                unitRealNameZykUser: {},//1.2 当前资源库建设单位注册用户情况 - 实名用户数
                resourceConstructionSituation: {},//1.3 人才培养方案,课程知识图谱,教学标准,题库数及使用率
                statResourceDataCapacity: {
                    total:0,
                    textNum:0,
                    graphicImageNum:0,
                    videoNum:0,
                    animationNum:0,
                    virtualSimulationNum:0,
                    smallCourseNum:0,
                    shenyangNum:0,
                    pptNum:0,
                    mediaNum:0,
                    coursewareNum:0,
                    otherNum:0
                },//1.3 各类资源容量
            };
        },
        created() {
            if (this.$route.query) {
                // this.header = this.$route.query;
                let token = this.$route.query.token;
                sessionStorage.setItem("lrmv2token", token);
                let zykid = this.$route.query.zykid;
                this.dataChange(zykid);
                this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName);
                this.isRank = this.$route.query.isRank;
                //const year = this.$route.query.yearOrMonth
                //const monthly = this.$route.query.yearOrMonth
                // const year = this.$route.query.yearOrMonth.substring(0, 4);
                // const monthly = this.$route.query.yearOrMonth.substring(4, this.$route.query.yearOrMonth.length);
                //this.$route.query.startTime = `${year}-${monthly}-${1}`;
                //this.$route.query.endTime = `${year}-${monthly}-${new Date(year, monthly, 0).getDate()}`;
                let year = this.$route.query.yearOrMonth.substring(0, 4);
                let monthly = this.$route.query.yearOrMonth.substring(
                    4,
                    this.$route.query.yearOrMonth.length
                );
                this.header.zykNum = this.$route.query.zykNum;
                // this.header.startTime = this.$route.query.startDay;
                // this.header.endTime = this.$route.query.endDay;
                this.header.startTime = year + "-" + monthly + "-" + "01";
                this.header.endTime = year + "-" + monthly + "-" + new Date(year, monthly, 0).getDate();
                this.year = year + "-" + monthly;
                this.yearMonthText = year + "年" + monthly + "月";
                //this.year = `${year}-${monthly}`;
                //this.yearAndMonthly = this.$route.query.yearOrMonth;
            }
            setTimeout(() => {
                this.getZykStatus(); //   获取资源库状态
                this.getZykServiceMajor();
                this.fenxi(); //   年度基本信息
                this.resourceLibraryDom(); //  图1  资源库注册用户类型分布总体情况
                this.typeDistributionDom(); //  图2  当前资源库资源、课程情况
                this.getUserCountUnitDom(); // 当前资源库建设单位注册用户情况
                this.standardizationDom();
                this.behaviorTypesDom();
                this.resourcePoolDom();
                this.getLrmv2YearBehaviorUserCourseLog(); //图14 上半年用户访问时间段分布
                // this.usersMonthDom(); //  图3  用户新增情况(教师,学生)
                this.resourcesMonthDom(); //   图4  素材资源新增情况、
                // this.tops(); //        排名
                this.getStudyList(); //   标准化课程数
                this.accessMonthDom(); //   图6  资源访问情况
                this.visitsMonthDom(); //   图7  课程访问情况
                this.userAccessMonthDom(); //   图8  用户访问情况
                this.tearcherTop(); //   表1  教师访问量前十排名
                this.studentTop(); //    表2 学生访问量前十排名
                this.resourcesTop(); //   表3  资源访问量前十排名
                this.courseTop(); //    表4 课程访问量前十排名

                this.getRealNameZykUser(); //   1.1 当前资源库用户情况 - 实名用户数
                this.getUnitRealNameZykUser(); //    1.2 当前资源库建设单位注册用户情况 - 实名用户数
                //1.3 当前资源库资源建设情况
                this.getResourceConstructionSituation(); //  人才培养方案,课程知识图谱,教学标准,题库数及使用率
                this.getStatResourceDataCapacity(); //    各类资源容量


            }, 2000);
        },
        watch: {
            completeNum(val) {
                console.log(val);
            },
        },
        methods: {
            // 导出pdf文件
            exportPdf() {
                const lableList = document.getElementsByClassName("page-box");
                let name = this.header.zykName.split("(");
                let newName = "";
                let oldName = "";
                let zykName = "";
                if (name.length > 1) {
                    newName = name[0];
                    oldName = name[1].replace(")", "");
                    zykName = `${newName}（原专业名称：${oldName}）`;
                } else zykName = this.header.zykName;
                let schools = this.header.allHostUnit;
                let firstSchool = schools.split("，")[0]
                // pageToPDF(`${this.header.zykNum}_${zykName}_月报`, this.$refs.pdfContent, lableList);
                pageToPDF(`${this.province}_${zykName}_${firstSchool}_月报`, this.$refs.pdfContent, lableList);
            },
            formatValue(num) {
                return num.toFixed(2);
            },
            processName(val){
                return val.replaceAll("专业教学资源库","").replaceAll("教学资源库","").replaceAll("资源库","")
            },
            // 切换专业
            dataChange(e) {
                this.$axios
                    .post(this.$apiurls.major_switch, e, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            sessionStorage.setItem("zykId", e);
                            this.reload();
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            reload() {
                //切换专业刷新视图层
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true;
                });
            },
            // 导出月报
            toImage() {
                this.loading = this.$loading({
                    lock: true,
                    text: "正在导出中，请稍后...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });

                this.$axios
                    .post(
                        this.$apiurls.exportMonthReport,
                        {
                            courseName: "",
                            isAll: false,
                            month: this.yearAndMonthly,
                            reportType: 0,
                            zykId: sessionStorage.getItem("zykId"),
                            zykName: this.header.zykName,
                            zykNum: this.header.zykNum,
                        },
                        {
                            loading: false,
                        }
                    )
                    .then((res) => {
                        if (res.data) {
                            window.open(res.data);
                            this.loading.close();
                        }
                        this.completeNum = this.completeNum + 1;
                    })
                    .catch(() => {
                        this.loading.close();
                    });
            },
            // 获取资源库状态
            getZykServiceMajor() {
                this.$axios
                    .get(this.$apiurls.zykServiceMajors, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            this.serviceMajor = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 获取资源库状态
            getZykStatus() {
                this.$axios
                    .post(this.$apiurls.report_monthly_getZykStatus, sessionStorage.getItem("zykId"), {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            this.zykStatus = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            // 年度基本信息
            fenxi() {
                this.$axios
                    .post(this.$apiurls.report_yaer_getZykInformationVo, {
                        loading: false,
                    })
                    .then((res) => {
                        if(res.data){
                            this.header.zykName = res.data.zykName;
                            this.header.coHostUnit = res.data.coHostUnit;
                            this.header.hostUnit = res.data.hostUnit;
                            this.header.status = res.data.status;
                            this.header.allHostUnit = res.data.allHostUnit.replaceAll(",", "，");
                            this.yearText = parseInt(res.data.startTime.slice(0, 4));
                            this.usersMonthDomAndMajorUser(); // 图7、图8 本月用户新增情况、主持院校与参建院校新增占比情况 同步请求
                            // this.resourcesInsertDom();
                            this.resourcesMonthDom();
                            this.getYearReportByDataAnalysis1();
                            this.getYearReportByDataAnalysis2();
                            this.getYearReportByDataAnalysis3();
                            this.getYearReportByDataAnalysis4();
                            this.coursesMonthDom(); //   图5  课程新增
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 图1 资源库注册用户类型分布总体情况
            resourceLibraryDom() {
                this.$axios
                    .post(this.$apiurls.report_monthly_resourceLibrary, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            const arrList = [];
                            arrList.push(
                                {
                                    name: "教师",
                                    value: res.data.teacherNum,
                                },
                                {
                                    name: "学生",
                                    value: res.data.studentNum,
                                },
                                {
                                    name: "社会学习者",
                                    value: res.data.socialNum,
                                },
                                {
                                    name: "企业用户",
                                    value: res.data.enterpriseNum,
                                }
                            );
                            this.resourceLibrary.total = res.data.totalNum;
                            this.resourceLibrary.teacherNum = res.data.teacherNum;
                            this.resourceLibrary.studentNum = res.data.studentNum;
                            this.resourceLibrary.socialNum = res.data.socialNum;
                            this.resourceLibrary.enterpriseNum = res.data.enterpriseNum;
                            this.resourceLibrary.dataList = arrList;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            //图2 当前资源库参建单位注册用户情况
            getUserCountUnitDom() {
                this.$axios
                    .post(this.$apiurls.report_monthly_getUserCountUnit, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            var studentList = [];
                            var teacherList = [];
                            this.userCountUnit.cjteacherNum = res.data.teacherNum;
                            this.userCountUnit.cjstudentNum = res.data.studentNum;
                            this.userCountUnit.zcteacherNum = res.data.enterpriseNum;
                            this.userCountUnit.zcstudentNum = res.data.socialNum;
                            this.userCountUnit.teacherNum = res.data.teacherNum + res.data.enterpriseNum;
                            this.userCountUnit.studentNum = res.data.studentNum + res.data.socialNum;

                            teacherList.push(
                                {
                                    name: "主持单位教师",
                                    value: res.data.enterpriseNum,
                                },
                                {
                                    name: "参建单位教师",
                                    value: res.data.teacherNum,
                                }
                            );

                            studentList.push(
                                {
                                    name: "主持单位学生",
                                    value: res.data.socialNum,
                                },
                                {
                                    name: "参建单位学生",
                                    value: res.data.studentNum,
                                }
                            );
                            this.userCountUnit.studentList = studentList;
                            this.userCountUnit.teacherList = teacherList;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 图2 当前资源库资源、课程情况
            typeDistributionDom() {
                this.$axios
                    .post(this.$apiurls.report_year_getStatResourceDataEntity, 1, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            var arrList = [];
                            arrList.push(
                                {
                                    name: "视频类",
                                    value: res.data.videoNum,
                                },
                                {
                                    name: "动画类",
                                    value: res.data.animationNum,
                                },
                                {
                                    name: "图形图像类",
                                    value: res.data.graphicImageNum,
                                },
                                {
                                    name: "虚拟仿真类",
                                    value: res.data.virtualSimulationNum,
                                },
                                {
                                    name: "文本类",
                                    value: res.data.textNum,
                                },
                                {
                                    name: "微课类",
                                    value: res.data.smallCourseNum,
                                },
                                {
                                    name: "音频类",
                                    value: res.data.shenyangNum,
                                },
                                {
                                    name: "ppt和富媒体等",
                                    value: res.data.pptNum + res.data.coursewareNum + res.data.mediaNum,
                                },
                                {
                                    name: "其他",
                                    value: res.data.otherNum,
                                }
                            );
                            this.typeDistribution.spNumber = res.data.videoNum;
                            this.typeDistribution.dhNumber = res.data.animationNum;
                            this.typeDistribution.txtxNumber = res.data.graphicImageNum;
                            this.typeDistribution.xnfzNumber = res.data.virtualSimulationNum;
                            this.typeDistribution.wbNumber = res.data.textNum;
                            this.typeDistribution.wkNumber = res.data.smallCourseNum;
                            this.typeDistribution.ypNumber = res.data.shenyangNum;
                            this.typeDistribution.kjNumber = res.data.coursewareNum;
                            this.typeDistribution.pptNumber = res.data.pptNum;
                            this.typeDistribution.fmtNumber = res.data.mediaNum;
                            this.typeDistribution.qtNumber = res.data.otherNum;
                            this.typeDistribution.total = res.data.total;
                            this.typeDistribution.dataList = arrList;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 图4 该资源库标准化课程访问量排名
            standardizationDom() {
                this.$axios
                    .post(this.$apiurls.report_monthly_standardization, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            var name = [];
                            var value = [];
                            for (let i = 0; i < res.data.lrmv2UserResourceCourseRankingLogEntities.length; i++) {
                                name.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].name);
                                value.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].num);
                            }
                            this.standardization.dataList = value;
                            this.standardization.transverseData = name;
                            this.standardization.colorList = this.colorList;
                            this.standardization.courseBzNum = res.data.courseBzNum;
                            this.standardization.courseCoreNum = res.data.courseCoreNum;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 图5 资源库用户行为类型分布
            behaviorTypesDom() {
                this.$axios
                    .post(this.$apiurls.report_monthly_behaviorTypes, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            var arrList = [];
                            arrList.push(
                                {
                                    name: "课程模块",
                                    value: res.data.courseModule,
                                },
                                {
                                    name: "资源素材模块",
                                    value: res.data.resourceModule,
                                },
                                {
                                    name: "论坛模块",
                                    value: res.data.forumModule,
                                },
                                {
                                    name: "作业模块",
                                    value: res.data.taskModule,
                                },
                                {
                                    name: "考试模块",
                                    value: res.data.examinationModule,
                                },
                                {
                                    name: "其他模块",
                                    value: res.data.otherModule,
                                }
                            );
                            this.behaviorTypes.loginModule = res.data.loginModule;
                            this.behaviorTypes.courseModule = res.data.courseModule;
                            this.behaviorTypes.resourceModule = res.data.resourceModule;
                            this.behaviorTypes.forumModule = res.data.forumModule;
                            this.behaviorTypes.taskModule = res.data.taskModule;
                            this.behaviorTypes.examinationModule = res.data.examinationModule;
                            this.behaviorTypes.otherModule = res.data.otherModule;
                            this.behaviorTypes.total = res.data.total;
                            this.behaviorTypes.dataList = arrList;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 图6 资源库无活动数据情况
            resourcePoolDom() {
                this.$axios
                    .post(this.$apiurls.report_monthly_resourcePool, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            this.resourcePool = res.data;
                            this.waterDrop.teacher =
                                (this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100
                                    ? Math.round((this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100)
                                    : 0;
                            this.waterDrop.student =
                                (this.resourcePool.countStudent / this.resourcePool.realStudent) * 100
                                    ? Math.round((this.resourcePool.countStudent / this.resourcePool.realStudent) * 100)
                                    : 0;
                            this.waterDrop.resource =
                                (this.resourcePool.countResource / this.typeDistribution.total) * 100
                                    ? Math.round((this.resourcePool.countResource / this.typeDistribution.total) * 100)
                                    : 0;
                            this.waterDrop.teacherNum =
                                (this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100
                                    ? ((this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100).toFixed(
                                    2
                                    )
                                    : 0;
                            this.waterDrop.studentNum =
                                (this.resourcePool.countStudent / this.resourcePool.realStudent) * 100
                                    ? ((this.resourcePool.countStudent / this.resourcePool.realStudent) * 100).toFixed(
                                    2
                                    )
                                    : 0;
                            this.waterDrop.resourceNum =
                                (this.resourcePool.countResource / this.typeDistribution.total) * 100
                                    ? ((this.resourcePool.countResource / this.typeDistribution.total) * 100).toFixed(2)
                                    : 0;
                            // this.getLrmv2MonthUserCourseResource();
                            1;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            //图14 用户访问时间段分布
            getLrmv2YearBehaviorUserCourseLog() {
                this.$axios
                    .get(this.$apiurls.getMonthUserAccessDistribution, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            let data = res.data;
                            let arrList = [];
                            let total = 0;
                            for (let i = 0; i < data.length; i++) {
                                arrList.push([
                                    data[i].behaviorOne,
                                    data[i].behaviorTwo,
                                    data[i].behaviorThree,
                                    data[i].behaviorFour,
                                    data[i].behaviorFive,
                                    data[i].behaviorSix,
                                    data[i].behaviorSeven,
                                    data[i].behaviorEight,
                                ]);
                                total +=
                                    parseFloat(data[i].behaviorOne) +
                                    parseFloat(data[i].behaviorTwo) +
                                    parseFloat(data[i].behaviorThree) +
                                    parseFloat(data[i].behaviorFour) +
                                    parseFloat(data[i].behaviorFive) +
                                    parseFloat(data[i].behaviorSix) +
                                    parseFloat(data[i].behaviorSeven) +
                                    parseFloat(data[i].behaviorEight);
                            }
                            this.behaviorUser.dataList = arrList;
                            this.behaviorUser.transverseData = [
                                "00：00—03：00",
                                "03：00—06：00",
                                "06：00—09：00",
                                "09：00—12：00",
                                "12：00—15：00",
                                "15：00—18：00",
                                "18：00—21：00",
                                "21：00—00：00",
                            ];
                            this.behaviorUser.legendList = [
                                "教师行为",
                                "学生行为",
                                "企业用户行为",
                                "社会学习者行为",
                            ];
                            this.behaviorUser.total = total;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 图3 用户新增情况
            usersMonthDom() {
                this.$axios
                    .post(this.$apiurls.report_year_getYearhZykAdd, 14, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            const arrList = [];
                            for (let i = 0; i < res.data.length; i++) {
                                arrList.push(res.data[i].value);
                            }
                            let teacherNum = 0;
                            let studentNum = 0;
                            // 新增教师的数量
                            let teacherArray = res.data[0].value;
                            for (let i = 0; i <= teacherArray.length - 1; i++) {
                                teacherNum += parseFloat(teacherArray[i]);
                            }

                            // 新增学生的数量
                            let studentArray = res.data[1].value;
                            for (let i = 0; i <= studentArray.length - 1; i++) {
                                studentNum += parseFloat(studentArray[i]);
                            }
                            this.usersMonth.dataList = arrList;
                            this.usersMonth.transverseData = res.data[0].name;
                            this.usersMonth.legendList = ["教师", "学生"];
                            this.usersMonth.colorList = this.colorList;
                            this.usersMonth.teacherNum = teacherNum;
                            this.usersMonth.studentNum = studentNum;
                            this.usersMonth.total = teacherNum + studentNum;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            usersMonthDomAndMajorUser() {
                //同步发送请求
                // 图7 本月用户新增情况
                let p1 = new Promise((resolve, reject) => {
                    this.$axios
                        .post(this.$apiurls.getMonthUserAddSituation, this.year, {
                            loading: false,
                        })
                        .then((res) => {
                            resolve(res.data);
                            this.completeNum = this.completeNum + 1;
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
                // 图8 主持单位与参建单位新增用户占比情况
                let p2 = new Promise((resolve, reject) => {
                    this.$axios
                        .post(this.$apiurls.getChargeAndBuildUnitUserAdd, this.year, {
                            loading: false,
                        })
                        .then((res) => {
                            resolve(res.data);
                            this.completeNum = this.completeNum + 1;
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });

                Promise.all([p1, p2]).then((res) => {
                    // 图7 本月用户新增情况
                    let transverse = [];
                    let teacherNum = 0;
                    let studentNum = 0;
                    let enterpriseNum = 0;
                    let socialNum = 0;
                    for (let i = 0; i < res[0].teacher.length; i++) {
                        transverse.push(i + 1);
                        teacherNum += parseFloat(res[0].teacher[i]);
                    }
                    for (let i = 0; i < res[0].student.length; i++) {
                        studentNum += parseFloat(res[0].student[i]);
                    }
                    for (let i = 0; i < res[0].enterprise.length; i++) {
                        enterpriseNum += parseFloat(res[0].enterprise[i]);
                    }
                    for (let i = 0; i < res[0].social.length; i++) {
                        socialNum += parseFloat(res[0].social[i]);
                    }
                    this.usersMonth.transverseData = transverse;
                    this.usersMonth.teacherNum = teacherNum;
                    this.usersMonth.studentNum = studentNum;
                    this.usersMonth.enterpriseNum = enterpriseNum;
                    this.usersMonth.socialNum = socialNum;
                    this.usersMonth.dataList = [
                        res[0].teacher,
                        res[0].student,
                        res[0].enterprise,
                        res[0].social,
                    ];
                    this.usersMonth.legendList = ["教师", "学生", "企业用户", "社会学习者"];

                    // 图8 主持单位与参建单位新增用户占比情况
                    this.majorUser = res[1];
                    this.waterDrop.majorteacherNum = parseFloat(
                        teacherNum ? ((this.majorUser.teacher / teacherNum) * 100).toFixed(2) : 0
                    );
                    this.waterDrop.majorstudentNum = parseFloat(
                        studentNum ? ((this.majorUser.student / studentNum) * 100).toFixed(2) : 0
                    );
                    this.waterDrop.unitteacherNum = parseFloat(
                        teacherNum ? ((this.majorUser.cjteacher / teacherNum) * 100).toFixed(2) : 0
                    );
                    this.waterDrop.unitstudentNum = parseFloat(
                        studentNum ? ((this.majorUser.cjstudent / studentNum) * 100).toFixed(2) : 0
                    );
                });
            },
            // 图9 素材资源新增情况
            resourcesMonthDom() {
                //同步发送请求
                //图9 素材资源新增情况 饼状图
                let p1 = new Promise((resolve, reject) => {
                  this.$axios
                      .post(this.$apiurls.getMonthResourceAddSituation, this.year, {
                          loading: false,
                      })
                      .then((res) => {
                          if (res.code == 200) {
                              resolve(res.data);
                          }
                          this.completeNum = this.completeNum + 1;
                      })
                      .catch((err) => {
                          reject(err);
                      });
                });
                //图9 素材资源新增情况 柱状图
                let p2 = new Promise((resolve, reject) => {
                  this.$axios
                      .post(this.$apiurls.getMonthResourceNumAddSituation, this.year, {
                          loading: false,
                      })
                      .then((res) => {
                          if (res.code == 200) {
                              resolve(res.data);
                          }
                          this.completeNum = this.completeNum + 1;
                      })
                      .catch((err) => {
                          reject(err);
                      });
                });

                Promise.all([p1, p2]).then((res) => {
                    let res1 = res[0];
                    let number = 0;
                    let total = 0;
                    let arrList = [];
                    let legendList = [];
                    for (let i = 0; i < res1.length; i++) {
                        let detailed_type = "";
                        switch (res1[i].detailedType) {
                            case 1:
                                detailed_type = "视频";
                                arrList.push({
                                    name: detailed_type,
                                    value: res1[i].num,
                                });
                                legendList.push(detailed_type);
                                break;
                            case 2:
                                detailed_type = "动画";
                                arrList.push({
                                    name: detailed_type,
                                    value: res1[i].num,
                                });
                                legendList.push(detailed_type);
                                break;
                            case 3:
                                detailed_type = "图形图像";
                                arrList.push({
                                    name: detailed_type,
                                    value: res1[i].num,
                                });
                                legendList.push(detailed_type);
                                break;
                            case 4:
                                detailed_type = "虚拟仿真";
                                arrList.push({
                                    name: detailed_type,
                                    value: res1[i].num,
                                });
                                legendList.push(detailed_type);
                                break;
                            case 5:
                                detailed_type = "文本";
                                arrList.push({
                                    name: detailed_type,
                                    value: res1[i].num,
                                });
                                legendList.push(detailed_type);
                                break;
                            case 6:
                                detailed_type = "微课";
                                arrList.push({
                                    name: detailed_type,
                                    value: res1[i].num,
                                });
                                legendList.push(detailed_type);
                                break;
                            case 7:
                                detailed_type = "音频";
                                arrList.push({
                                    name: detailed_type,
                                    value: res1[i].num,
                                });
                                legendList.push(detailed_type);
                                break;
                            case 8:
                                number += res1[i].num;
                                break;
                            case 9:
                                number += res1[i].num;
                                break;
                            case 10:
                                number += res1[i].num;
                                break;
                            case 11:
                                detailed_type = "其他";
                                arrList.push({
                                    name: detailed_type,
                                    value: res1[i].num,
                                });
                                legendList.push(detailed_type);
                                break;
                        }
                        total += parseFloat(res1[i].num);
                    }
                    if (number > 0) {
                        arrList.push({
                            name: "ppt和富媒体等",
                            value: number,
                        });
                        legendList.push("ppt和富媒体等");
                    }
                    this.resourcesMonth.dataList = arrList;
                    this.resourcesMonth.total = total;
                    this.resourcesMonth.colorList = this.colorList;
                    this.resourcesMonth.legendList = ["新增资源"];

                    let res2 = res[1];
                    let transverseData = [];
                    for (let i = 0; i < res2.resource.length; i++) {
                        transverseData.push(i + 1);
                    }
                    this.resourcesMonth.dataList2 = res2.resource;
                    this.resourcesMonth.transverseData = transverseData;
                });
            },
            resourcesInsertDom() {
                this.$axios
                    .get(this.$apiurls.get1244ResourceDistribution+"?startTime="+this.header.startTime+"&endTime="+this.header.endTime, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            this.resourcesInsert.dataList = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 排名
            tops() {
                this.$axios
                    .post(this.$apiurls.report_1244_getZykRankYear, {
                        loading: false,
                    })
                    .then((res) => {
                        if(res.data){
                            /**
                             * 排在前 10%名次作为优秀，前11%-30%为良好，31%-70%为中等，后30%作为差。基数为所有参与排名的资源库数。
                             */
                            let rank = res.data.zykRank;
                            let rankPercent = (rank/782) * 100;
                            if(rankPercent<=10){
                                this.rankDesc = "A";
                            }
                            if(rankPercent>=11 && rankPercent<=30){
                                this.rankDesc = "B";
                            }
                            if(rankPercent>=31 && rankPercent<=70){
                                this.rankDesc = "C";
                            }
                            if(rankPercent>70){
                                this.rankDesc = "D";
                            }
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 标注化课程数
            getStudyList() {
                this.$axios
                    .post(this.$apiurls.report_year_getYearStatStandardcourseaccessList, {
                        loading: false,
                    })
                    .then((res) => {
                        if(res.data){
                            this.totalNum = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            // 图5 课程新增情况
            coursesMonthDom() {
                this.$axios
                    .post(this.$apiurls.getMonthCourseNumAddSituation, this.year, {
                        loading: false,
                    })
                    .then((res) => {
                        if(res.data){
                            let transverse = [];
                            for (let i = 0; i < res.data.standardCourse.length; i++) {
                                transverse.push(i + 1);
                            }
                            this.coursesMonth.dataList = [res.data.standardCourse, res.data.personalityCourse];
                            this.coursesMonth.legendList = ["标准化课程", "个性化课程"];
                            this.coursesMonth.transverseData = transverse;
                            this.coursesMonth.standard = res.data.standardCourse.reduce((a, b) => parseInt(a) + parseInt(b), 0);
                            this.coursesMonth.personal = res.data.personalityCourse.reduce((a, b) => parseInt(a) + parseInt(b), 0);
                            this.coursesMonth.total = this.coursesMonth.standard + this.coursesMonth.personal;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            // 图11 资源访问情况
            accessMonthDom() {
                this.$axios
                    .post(this.$apiurls.getMonthResourceAccessSituation, this.year, {
                        loading: false,
                    })
                    .then((res) => {
                        if(res.code == 200){
                            let data = res.data;
                            let transverse = [];
                            let total = 0;
                            for (let i = 0; i < data.length; i++) {
                                transverse.push(i + 1);
                                total += parseFloat(data[i]);
                            }
                            this.accessMonth.dataList = data;
                            this.accessMonth.transverseData = transverse;
                            this.accessMonth.legendList = ["资源访问"];
                            this.accessMonth.total = total;
                            this.accessMonth.colorList = this.colorList;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            // 图12 课程访问情况
            visitsMonthDom() {
                this.$axios
                    .post(this.$apiurls.getMonthCourseAccessSituation, this.year, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            let data = res.data;
                            let transverse = [];
                            let total = 0;
                            for (let i = 0; i < data.length; i++) {
                                transverse.push(i + 1);
                                total += parseFloat(data[i]);
                            }
                            this.visitsMonth.dataList = data;
                            this.visitsMonth.transverseData = transverse;
                            this.visitsMonth.legendList = ["课程访问"];
                            this.visitsMonth.total = total;
                            this.visitsMonth.colorList = this.colorList;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            //图13  用户访问情况
            userAccessMonthDom() {
                this.$axios
                    .post(this.$apiurls.getMonthUserAccessSituation, this.year, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            let data = res.data;
                            let transverse = [];
                            for (let i = 0; i < data.teacher.length; i++) {
                                transverse.push(i + 1);
                            }
                            this.userAccessMonth.dataList = [
                                data.teacher,
                                data.student,
                                data.enterprise,
                                data.social,
                            ];
                            this.userAccessMonth.transverseData = transverse;
                            this.userAccessMonth.legendList = [
                                "教师行为",
                                "学生行为",
                                "企业用户行为",
                                "社会学习者行为",
                            ];
                            this.userAccessMonth.total = data.total;
                            this.userAccessMonth.colorList = this.colorList;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            // 表1 本月访问量较多的教师（前10名）
            tearcherTop() {
                this.$axios
                    .get(
                        this.$apiurls.getMonthAccessMoreTeacherRank,
                        {
                            loading: false,
                        }
                    )
                    .then((res) => {
                        if(res.code == 200){
                            this.tearcherList.dataList = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            studentTop() {
                this.$axios
                    .get(
                        this.$apiurls.getMonthAccessMoreStudentRank,
                        {
                            loading: false,
                        }
                    )
                    .then((res) => {
                        if(res.code == 200){
                            this.studentList.dataList = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            resourcesTop() {
                this.$axios
                    .post(this.$apiurls.getLrmv2YearVisitCourseOrResourceRank, 47, {
                        loading: false,
                    })
                    .then((res) => {
                        if(res.data){
                            this.resourcesList.dataList = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            courseTop() {
                this.$axios
                    .post(this.$apiurls.getLrmv2YearVisitCourseOrResourceRank, 48, {
                        loading: false,
                    })
                    .then((res) => {
                        let data = res.data
                        if(data){
                            for (const item of data) {
                                let arr = item.name.split("_");
                                item.name = arr[0];
                                item.type = arr[1];
                            }
                            this.courseList.dataList = data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            // 年报-年份数据对比分析 (资源总数对比分析)
            getYearReportByDataAnalysis1() {
                this.$axios
                    .post(
                        this.$apiurls.getYearDataAddAnalysis,
                        { type: 1, year: this.yearText },
                        {
                            loading: false,
                        }
                    )
                    .then((res) => {
                        if(res.data){
                            this.zykTotal.dataList = res.data.dataList;
                            this.zykTotal.colorList = this.colorList;
                            this.zykTotal.legendList = res.data.year;
                            this.zykTotal.transverseData = res.data.transverseData;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            // 年报-年份数据对比分析 (课程总数对比分析)
            getYearReportByDataAnalysis2() {
                this.$axios
                    .post(
                        this.$apiurls.getYearDataAddAnalysis,
                        { type: 2, year: this.yearText },
                        {
                            loading: false,
                        }
                    )
                    .then((res) => {
                        if(res.data){
                            this.courseTotal.dataList = res.data.dataList;
                            this.courseTotal.colorList = this.colorList;
                            this.courseTotal.legendList = res.data.year;
                            this.courseTotal.transverseData = res.data.transverseData;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            // 年报-年份数据对比分析 (用户数对比分析)
            getYearReportByDataAnalysis3() {
                this.$axios
                    .post(
                        this.$apiurls.getYearDataAddAnalysis,
                        { type: 3, year: this.yearText },
                        {
                            loading: false,
                        }
                    )
                    .then((res) => {
                        if(res.data){
                            this.userTotal.dataList = res.data.dataList;
                            this.userTotal.colorList = this.colorList;
                            this.userTotal.legendList = res.data.year;
                            this.userTotal.transverseData = res.data.transverseData;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },

            // 年报-年份数据对比分析 (访问量对比分析)
            getYearReportByDataAnalysis4() {
                this.$axios
                    .post(
                        this.$apiurls.getYearReportByDataAnalysis,
                        { type: 4, year: this.yearText },
                        {
                            loading: false,
                        }
                    )
                    .then((res) => {
                        if(res.data){
                            this.fangwen.dataList = res.data.dataList;
                            this.fangwen.colorList = this.colorList;
                            this.fangwen.legendList = res.data.transverseData;
                            this.fangwen.transverseData = res.data.legendList;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            dataHandler(data) {
                return data > 100000000
                    ? (data / 100000000).toFixed(2) + "亿"
                    : data > 10000
                        ? (data / 10000).toFixed(2) + "万"
                        : data;
            },
            // 进度条上的百分比值转化
            teacherFormat() {
                return `${this.waterDrop.teacherNum}%`;
            },
            studentFormat() {
                return `${this.waterDrop.studentNum}%`;
            },
            resourceFormat() {
                return `${this.waterDrop.resourceNum}%`;
            },
            getRealNameZykUser() {//1.1 当前资源库用户情况 - 实名用户数
                this.$axios
                    .get(this.$apiurls.getRealNameZykUser, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            this.realNameZykUser = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            getUnitRealNameZykUser() {//1.2 当前资源库建设单位注册用户情况 - 实名用户数
                this.$axios
                    .get(this.$apiurls.getUnitRealNameZykUser, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            this.unitRealNameZykUser = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            getResourceConstructionSituation() {//1.3 人才培养方案,课程知识图谱,教学标准,题库数及使用率
                this.$axios
                    .post(this.$apiurls.getResourceConstructionSituation, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            this.resourceConstructionSituation = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
            getStatResourceDataCapacity() {//1.3 人才培养方案,课程知识图谱,教学标准,题库数及使用率
                this.$axios
                    .post(this.$apiurls.getStatResourceDataCapacity, {
                        loading: false,
                    })
                    .then((res) => {
                        if (res.data) {
                            this.statResourceDataCapacity = res.data;
                        }
                        this.completeNum = this.completeNum + 1;
                    });
            },
        },
    };
</script>

<style scoped>
  .analysisReport {
    width: 100%;
    background: #fff;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    margin: 0rem;
    padding: 0rem;
  }

  .right {
    float: right;
    margin-right: 20px;
    font-size: 32px;
  }

  .analysisReport_box {
    /* width: 85%; */
    /* margin: 0rem auto; */
    /* padding: 0 7.5%; */
    /* height: 19180px; */
  }

  .header_titles {
    display: flex;
    justify-content: center;
    flex-flow: column;
    color: #000;
    text-align: center;
    position: relative;
  }

  .header_titles h1 {
    font-size: 45px;
    font-weight: bold;
    color: #1d244e;
  }

  .header_titles .monthly {
    font-size: 40px;
    font-weight: 400;
    color: #1d244e;
    line-height: 30px;
    margin-top: 6px;
  }

  .number_time {
    margin: 40px 0 60px 0;
  }

  .number_time div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #707f9d;
    font-size: 1.5625rem;
  }

  .number_time p {
    width: 100%;
    height: 0.0625rem;
    background: #707f9d;
    margin-top: 0.5rem;
  }

  .number_time p:last-child {
    opacity: 0.5;
    margin-top: 0.25rem;
  }

  .division {
    position: relative;
    clear: both;
    text-align: center;
    font-weight: bold;
    font-size: 44px;
    color: #1d244e;
  }

  .chart_box h4 {
    font-weight: 700;
    font-size: 42px;
    color: #1d244e;
    line-height: 100px;
    width:92%;
    margin: 0 auto;
  }

  .chart_box p {
    font-size: 35px;
    text-indent: 2em;
    line-height: 60px;
    color: #707f9d;
    width:92%;
    margin: 0 auto;
  }

  .chart_box .echartsHeight,
  .layout,
  .speed {
    width: 90%;
    /* height: calc(100vw / 1080 * 300); */
    height: 28rem;
    margin: 0 auto;

  }

  .speed {
    width: 100%;
    height: auto;
  }

  .speed > div {
    width: 80%;
    font-size: 1.5625rem;
    color: #707f9d;
    line-height: 1.75rem;
    margin: 1.25rem auto;
  }

  .speed .el-col {
    margin-bottom: 0.9375rem;
  }

  .speed .el-col div {
    height: 2.5rem;
    display: flex;
    align-items: center;
  }

  .speed .el-col-6 {
    white-space: nowrap;
  }

  .chart_box .chart_name {
    text-align: center;
    font-size: 30px;
    color: #707f9d;
    clear: both;
    margin-top: 20px;
  }

  .chart_box .notes {
    margin: 0 auto;
    line-height: 50px;
    font-size: 30px;
    color: #707f9d;
    width: 90%;
  }

  /* 布局 */
  .layout {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .export {
    position: absolute;
    right: 0.625rem;
    top: 0.625rem;
    z-index: 1;
  }

  .center {
    text-align: center;
  }

  ::v-deep .el-progress-bar__innerText {
    color: #000;
    font-size: 1.5625rem;
  }
</style>
<style lang="scss" scoped>
  .page-box {
    // padding: 7% 0;
    //height: 2740px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    // border: 1px solid red;
    .m-top150 {
      margin-top: 150px;
    }

    .biaoge {
      width: 95%;
      margin: 25px auto;

      .course {
        text-align: center;
        margin: 0px 10px;

        tr {
          height: 42px;
          color: #707f9d;
          font-size: 22px;

          &:nth-child(2n) {
            background: #fff;
            color: #566178;
          }

          &:nth-child(2n-1) {
            background: #7ed2ff;
            color: #566178;
          }
        }
      }
    }
  }

  .flex-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    & > div {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
</style>
